module.exports = __webpack_public_path__ + "img/lncipedia.b142be63.png";